import { render, staticRenderFns } from "./UploadTableHead.vue?vue&type=template&id=13269b28&"
import script from "./UploadTableHead.vue?vue&type=script&lang=js&"
export * from "./UploadTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports